import { useMutation } from "react-query";
import { print, printLabel } from "../../../services/printDriver";

export const usePrintMutation = () => {
  return useMutation((data) => print(data));
};

export const useLabelPrintMutation = () => {
  return useMutation((data) => printLabel(data));
};
